<template>
  <div>
    <div class="form-row">
      <div id="card-element">
        <!-- a Stripe Element will be inserted here. -->
      </div>

      <p class="receipt">A receipt of this transaction will be emailed to you.</p>
      <!-- Used to display form errors -->
      <div id="card-errors" role="alert"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CreditCardForm',
  mounted(){
    // Create a Stripe client
    var stripe = Stripe(location.port ? 'pk_test_sqc5TkzskX6KlDziFbOqiJnp' : 'pk_live_cbOV0nOnVVGVkU0RtcRZw6yQ'); // Production runs on port 80

    // Create an instance of Elements
    var elements = stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    // Create an instance of the card Element
    this.card = elements.create('card', {style: style});

    // Add an instance of the card Element into the `card-element` <div>
    this.card.mount('#card-element');

    let completed = false;

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener('change', function(event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }

      if(event.complete){
        this.bus.$emit('creditCardEntered');
      }

      completed = event.complete;
    }.bind(this));

    let getCard = ()=>{
      return this.card;
    }

    this.bus._events['billingFormSaved'] = [];
    this.bus.$on('billingFormSaved', function (id) {
      if(!completed) return this.bus.$emit('noCardValidation');

      stripe.createToken(this.card).then(function(result) {
        if (result.error) {
          // Inform the user if there was an error
          var errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
        } else {
          // Send the token to your server
          this.bus.$emit('cardValidated', result.token);
        }
      }.bind(this));
    }.bind(this))

    this.bus._events['cardCleared'] = [];
    this.bus.$on('cardCleared', function(){
      this.card.clear();
    }.bind(this));
  },
  components: {
  },
  methods: {
    update(){
      this.$emit('input', null);
    }
  },
  computed: {

  },
  data(){
    return {
      result: null
    }
  },
  watch: {
  },
  props: ['bus']
}
</script>



// WEBPACK FOOTER //
// src/components/common/CreditCardForm.vue